import { useNavigate } from "react-router-dom";
import styles from "./Table.module.css";

const Table = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.tableWrapper}>
      <div className="card">
        <table className={styles.table}>
          <thead className="table-light">
            <tr>
              <th>Sr.No.</th>
              <th>Guest</th>
              <th>Contact</th>
              <th>Registered On</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td className={styles.nameCell}>
                <div
                  style={{ cursor: "pointer" }}
                  className={styles.userName}
                  onClick={() => navigate("/customers/customer-details")}
                >
                  Mr. John Doe
                </div>
                <div className={styles.userCode}>
                  <strong>CUST-001</strong>
                </div>
              </td>
              <td>
                <div className={styles.iconWrapper}>
                  <span>9876543210</span>
                </div>
                <div className={styles.iconWrapper}>
                  <span>whatsapp: 9876543210</span>
                </div>
              </td>
              <td>
                <div className={styles.iconWrapper}>
                  <span>18-Mar-2026</span>
                </div>
              </td>
            </tr>

            <tr>
              <td>2</td>
              <td className={styles.nameCell}>
                <div
                  style={{ cursor: "pointer" }}
                  className={styles.userName}
                  onClick={() => navigate("/customers/customer-details")}
                >
                  Ms. Jane Smith
                </div>
                <div className={styles.userCode}>
                  <strong>CUST-002</strong>
                </div>
              </td>
              <td>
                <div className={styles.iconWrapper}>
                  <span>8765432109</span>
                </div>
                <div className={styles.iconWrapper}>
                  <span>whatsapp: 8765432109</span>
                </div>
              </td>
              <td>
                <div className={styles.iconWrapper}>
                  <span>17-Mar-2026</span>
                </div>
              </td>
            </tr>

            {/* Promoted Customer Section */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
